var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenurugby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.009,
    height: 19.511,
    viewBox: "0 0 66.009 19.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menurugby",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HandBall",
    d: "M5.619-8.132c0,.934-.539,1.6-1.771,1.6h-1.6v-3.16h1.6C5.093-9.688,5.619-9.077,5.619-8.132ZM1.155-10.585v8.342H2.244V-5.654H3.561L5.548-2.243h1.3L4.758-5.738A2.352,2.352,0,0,0,6.744-8.132c0-1.364-.934-2.454-2.9-2.454ZM14.249-8.8H13.16v3.6c0,1.412-.754,2.106-1.879,2.106A1.759,1.759,0,0,1,9.449-5.1V-8.8H8.372V-4.96a2.559,2.559,0,0,0,2.693,2.813A2.411,2.411,0,0,0,13.16-3.213v.969h1.089Zm1.436,3.255A3.156,3.156,0,0,0,18.8-2.135a2.741,2.741,0,0,0,2.442-1.34V-2.1A1.947,1.947,0,0,1,19.2.043a2.036,2.036,0,0,1-2.095-1.329H16.032C16.248.115,17.48.988,19.2.988A2.94,2.94,0,0,0,22.34-2.1V-8.8h-1.1v1.2A2.7,2.7,0,0,0,18.8-8.91,3.108,3.108,0,0,0,15.685-5.547Zm5.553.012a2.244,2.244,0,0,1-2.226,2.442A2.246,2.246,0,0,1,16.8-5.547a2.215,2.215,0,0,1,2.214-2.418A2.247,2.247,0,0,1,21.238-5.535Zm4.033-2.047V-11.1H24.183v8.857h1.089V-3.452a2.737,2.737,0,0,0,2.454,1.317,3.156,3.156,0,0,0,3.112-3.411A3.1,3.1,0,0,0,27.725-8.91,2.779,2.779,0,0,0,25.272-7.581Zm4.452,2.035A2.248,2.248,0,0,1,27.5-3.093a2.251,2.251,0,0,1-2.226-2.442A2.254,2.254,0,0,1,27.5-7.964,2.217,2.217,0,0,1,29.724-5.547Zm5.039,2.059L32.7-8.8H31.5l2.645,6.487L32.848.845h1.125L37.923-8.8H36.8Z",
    transform: "translate(27.341 14.291)",
    fill: "#b54213",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22765",
    "data-name": "Group 22765",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16911",
    "data-name": "Rectangle 16911",
    width: 19.511,
    height: 19.511,
    transform: "translate(0 0)",
    fill: "#9ed339",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_4_",
    "data-name": "svgexport-6 (4)",
    transform: "translate(1.241 1.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3283",
    "data-name": "Path 3283",
    d: "M10.081.147a12.453,12.453,0,0,0-6.453,3.48,12.452,12.452,0,0,0-3.48,6.453c-.412,2.252-.006,4.187,1.113,5.308a5.061,5.061,0,0,0,3.648,1.27A9.239,9.239,0,0,0,6.569,16.5a12.453,12.453,0,0,0,6.453-3.48A12.452,12.452,0,0,0,16.5,6.567c.412-2.252.006-4.186-1.113-5.308S12.334-.266,10.081.147ZM4.02,4.019A11.354,11.354,0,0,1,11.706.538c.052,0,.1,0,.153.005A16.257,16.257,0,0,0,4.814,4.812a16.267,16.267,0,0,0-4.27,7.057A11.271,11.271,0,0,1,4.02,4.019Zm8.609,8.609A11.27,11.27,0,0,1,4.777,16.1a16.251,16.251,0,0,0,7.059-4.27,16.25,16.25,0,0,0,4.27-7.057,11.27,11.27,0,0,1-3.477,7.851Zm-1.185-1.185c-3.128,3.126-6.62,4.425-8.553,4.323a3.474,3.474,0,0,1-1.236-.772,3.477,3.477,0,0,1-.771-1.237C.777,11.82,2.08,8.331,5.206,5.2S11.815.783,13.75.881A3.489,3.489,0,0,1,15,1.652a3.477,3.477,0,0,1,.772,1.237c.1,1.936-1.2,5.426-4.324,8.552Z",
    transform: "translate(0.009 0.011)",
    fill: "#b54213"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3284",
    "data-name": "Path 3284",
    d: "M11.461,11.461c-2.953,2.953-4.419,6.864-3.078,8.205a2,2,0,0,0,1.462.5c1.805,0,4.541-1.376,6.743-3.578,2.953-2.952,4.419-6.863,3.078-8.2s-5.253.126-8.205,3.078ZM16.2,16.2c-2.907,2.907-6.436,4.061-7.42,3.078s.171-4.513,3.078-7.42C14.078,9.63,16.666,8.432,18.2,8.432a1.486,1.486,0,0,1,1.074.345C20.257,9.759,19.1,13.289,16.2,16.2Z",
    transform: "translate(-5.691 -5.691)",
    fill: "#b54213"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3285",
    "data-name": "Path 3285",
    d: "M24.358,19.7a.278.278,0,0,0-.393,0L19.7,23.965a.278.278,0,1,0,.393.393L24.358,20.1A.278.278,0,0,0,24.358,19.7Z",
    transform: "translate(-14.17 -14.17)",
    fill: "#b54213"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3286",
    "data-name": "Path 3286",
    d: "M28.513,25.674l-2.841,2.841a.278.278,0,1,0,.394.393l2.84-2.84a.278.278,0,1,0-.393-.393Z",
    transform: "translate(-18.481 -18.482)",
    fill: "#b54213"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenurugby);
export default __webpack_public_path__ + "static/media/menurugby.5aa1656165bce4aced60992abb987e09.svg";
export { ForwardRef as ReactComponent };